import type { Product } from '@/services/products'
import { formatTnd } from './formatMoney'

/** Uses only API fields from products list (aggregated min/max when variants). Display-only. */
export function listProductDisplayPrice(p: Product): string {
  if (!p.has_variants) return formatTnd(p.price)
  const min = p.min_price
  const max = p.max_price
  if (min != null && max != null && min !== max) {
    return `${formatTnd(min)} – ${formatTnd(max)}`
  }
  if (min != null) return formatTnd(min)
  return formatTnd(p.price)
}
